var magicStyles = [".content[data-v-628af0bf] {\n  margin: 0 0 var(--magic-space, 16px);\n}"];

export default magicStyles;
